<template>
    <div class="menu-button-container">
        <button
            class="draggable-item-menu-btn draggable-item-menu-btn-green draggable-item-menu-btn-start-finish" @click="openModal">
            Finalizar
        </button>
        <transition name="slide-fade">
            <FinishOrderReferenceButtonActionModal
                v-if="showModal"
                :orderReference="orderReference"
                :endOfAction="endOfAction"
                :closeModal="closeModal"
            />
        </transition>
    </div>
</template>

<script>
import FinishOrderReferenceButtonActionModal from './FinishOrderReferenceButtonActionModal.vue';
export default {
    name: "FinishOrderReferenceButton",
    components: {
        FinishOrderReferenceButtonActionModal
    },
    props: {
        orderReference: {
            type: Object,
            required: true,
        },
        endOfAction: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            producedQuantity: 0,
            showModal: false,
        };
    },
    methods: {
        openModal() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
    },
};
</script>